/**
 * Free-gift progress bar animation.
 *
 * Purely visual. The Liquid snippet (snippets/scs-gift-bar.liquid) renders the
 * correct state server-side on every cart rerender, reading the same config and
 * qualifying-subtotal rule as scs-free-gift.js. This only animates the fill from
 * 0 to its target on mount so the movement reads as progress toward the reward.
 *
 * Events match scs-free-gift.js: the drawer dispatches cart:rerendered without
 * bubbles, so listen in capture phase on document.
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animate(bar) {
    const fill = bar.querySelector('.scs-gift-bar__fill');
    if (!fill) return;

    if (reduceMotion) {
      bar.removeAttribute('data-animating');
      return;
    }

    // Force to 0, then release to the inline target on the next frame so the
    // CSS width transition runs even though the node was just replaced.
    bar.setAttribute('data-animating', '');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => bar.removeAttribute('data-animating'));
    });
  }

  function run() {
    document.querySelectorAll('[data-scs-gift-bar]').forEach((bar) => {
      if (bar.dataset.scsAnimated === '1') return;
      bar.dataset.scsAnimated = '1';
      animate(bar);
    });
  }

  document.addEventListener('cart:rerendered', run, true);
  document.addEventListener('product:added', run, true);
  document.addEventListener('cart:refresh', run, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
